import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import "./LiveTableStatus.css";
import { Link } from "react-router-dom";
import { AlertMessageAudio } from "../../assets";

const LiveTableStatus = () => {
  const [onlineBillMasters, setOnlineBillMasters] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [openTableData, setOpenTableData] = useState([]);
  const [unpaidTableData, setUnpaidTableData] = useState([]);
  const [billNoTableData, setBillNoTableData] = useState([]);
  const [selectedBill, setSelectedBill] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [dateOption, setDateOption] = useState("current");

  console.log("onlineBillMasters", onlineBillMasters)
  
  const [taxes, setTaxes] = useState({ totalCgst: 0, totalSgst: 0, totalVat: 0 })
  const [messagedata, setMessageData] = useState([]);
  const [viewMessageId, setViewMessageId] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  console.log(messagedata)

  const [outlet, setOutlet] = useState(null);
  useEffect(() => {
    const selectedOutlet = JSON.parse(localStorage.getItem("SelectedOutlet"));
    if (selectedOutlet) {
      setOutlet(selectedOutlet);
    }
  }, []);

  console.log("check", outlet?.outlate_id);


  // Fetch Online Bill Masters data
  const fetchOnlineBillMasters = async () => {
    try {
      if (!outlet?.outlate_id) {
        console.warn("Outlet ID is not available yet.");
        return;
      }
  
      const apiUrl = process.env.REACT_APP_SERVER_API;
  
      // Run all three API requests in parallel
      const [billResponse, messageResponse, itemResponse] = await Promise.all([
        axios.get(`${apiUrl}OnlineBillMasters?outletId=${outlet.outlate_id}`),
        axios.get(`${apiUrl}SmsData?outletId=${outlet.outlate_id}`),
        axios.get(`${apiUrl}item-Master?outletId=${outlet.outlate_id}`)
      ]);
  
      // Process message data
      setMessageData(messageResponse.data.data);
  
      if (billResponse.data.success && itemResponse.data.data) {
        const bills = billResponse.data.data;
        const billItems = itemResponse.data.data;
  
        // Merge items into their respective bills using srNumber
        const mergedBills = bills.map(bill => {
          const itemsForBill = billItems.filter(item => item.srNumber === bill.srNumber);
          return {
            ...bill,
            BillItems: itemsForBill
          };
        });
  
        // Sort by table number and update state
        const sortedBills = mergedBills.sort((a, b) =>
          a.tblno?.localeCompare(b.tblno, undefined, { numeric: true, sensitivity: 'base' })
        );
  
        setOnlineBillMasters(sortedBills);
      } else {
        setOnlineBillMasters([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setOnlineBillMasters([]);
    }
  };
  
  
  useEffect(() => {
    if (outlet?.outlate_id && dateOption === "current") {
      fetchOnlineBillMasters(); // Initial call
  
      const interval = setInterval(() => {
        fetchOnlineBillMasters();
      }, 30000); // Runs every 10 seconds
  
      return () => clearInterval(interval); // Cleanup on unmount or condition change
    }
  }, [outlet, dateOption]);

  const handlePrevDate = () => {
    if (dateOption == "back") {
      const prevDate = new Date(selectedDate);
      prevDate.setDate(prevDate.getDate() - 1);
      const formattedDate = prevDate.toISOString().split("T")[0];
      setSelectedDate(formattedDate);
      // fetchOnlineBillMastersByDate(formattedDate);
    }
  };

  const handleNextDate = () => {
    if (dateOption == "back") {
      const nextDate = new Date(selectedDate);
      nextDate.setDate(nextDate.getDate() + 1);

      const today = new Date();
      const todayDate = today.getDate();
      const todayMonth = today.getMonth();
      const todayYear = today.getFullYear();

      const nextDateDay = nextDate.getDate();
      const nextDateMonth = nextDate.getMonth();
      const nextDateYear = nextDate.getFullYear();

      // Compare nextDate < today
      if (
        nextDateYear < todayYear ||
        (nextDateYear === todayYear && nextDateMonth < todayMonth) ||
        (nextDateYear === todayYear && nextDateMonth === todayMonth && nextDateDay < todayDate)
      ) {
        const formattedNextDate = nextDate.toISOString().split("T")[0];
        setSelectedDate(formattedNextDate);
        // fetchOnlineBillMastersByDate(formattedNextDate);
      } else {
        // Don't call API for today (22nd)
        console.log("Next date is today or later — no API call");
      }
    }
  };

  

  const fetchOnlineBillMastersByDate = async (selectedDate) => {
    try {
      if (!outlet?.outlate_id) {
        console.warn("Outlet ID is not available yet.");
        return;
      }
  
      const apiUrl = process.env.REACT_APP_SERVER_API;
  
      // Run both requests in parallel
      const [billResponse, itemResponse] = await Promise.all([
        axios.get(`${apiUrl}OnlineBillMasters-OrderHistory/${selectedDate}?outletId=${outlet.outlate_id}`),
        axios.get(`${apiUrl}item-history/${selectedDate}?outletId=${outlet.outlate_id}`)
      ]);
  
      if (billResponse.data.success && itemResponse.data.data) {
        const bills = billResponse.data.data;
        const billItems = itemResponse.data.data;
  
        // Merge items with their corresponding bills using srNumber
        const mergedBills = bills.map(bill => {
          const itemsForBill = billItems.filter(item => item.srNumber === bill.srNumber);
  
          return {
            ...bill,
            BillItems: itemsForBill
          };
        });
  
        // Optional: Sort by table number
        const sortedBills = mergedBills.sort((a, b) =>
          a.tblno?.localeCompare(b.tblno, undefined, { numeric: true, sensitivity: 'base' })
        );
  
        setOnlineBillMasters(sortedBills);
      } else {
        setOnlineBillMasters([]);
      }
    } catch (error) {
      console.error("Error fetching bill history by date:", error);
      setOnlineBillMasters([]);
    }
  };
  
  


  const handleShowClick = () => {

    fetchOnlineBillMastersByDate(selectedDate);

  };



  // Filter data by date and categorize tables
  const filterAndCategorizeTables = () => {


    // Separate data into Open, Unpaid, and Bill No categories
    setOpenTableData(onlineBillMasters.filter((item) => !item.isPrinted && !item.isSettled));
    setUnpaidTableData(onlineBillMasters.filter((item) => item.isPrinted && !item.isSettled));
    setBillNoTableData(onlineBillMasters.filter((item) => item.isPrinted && item.isSettled));


  };

  // useEffect(() => {
  //   fetchOnlineBillMasters();
  // }, []);

  useEffect(() => {
    filterAndCategorizeTables();
  }, [onlineBillMasters]);



  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleTableClick = (bill) => {
    setSelectedBill(bill);
    setShowModal(true);
  };


  useEffect(() => {
    if (selectedBill && selectedBill.BillItems) {
      const totTaxes = selectedBill.BillItems.reduce((acc, item) => {
        acc.totalCgst += item.cgstAmt;
        acc.totalSgst += item.sgstAmt;
        acc.totalVat += item.vatAmt;
        return acc;
      }, { totalCgst: 0, totalSgst: 0, totalVat: 0 });
      console.log("totTaxes", totTaxes);
      setTaxes(totTaxes);
    } else {
      console.log("BillItems not found.");
    }



  }, [selectedBill])

  const FoodItemTotal = onlineBillMasters.reduce((total, bill) => {
    const foodItemTotalInBill = bill.BillItems
      .filter(item => item.isFood && item.itemQty > 0 && !item.isCancelled && !item.isComplementory)
      .reduce((itemTotal, item) => itemTotal + item.itemAmt, 0);

    return total + foodItemTotalInBill;
  }, 0);

  console.log("FoodItemTotal:", FoodItemTotal.toFixed(2));

  const BarItemTotal = onlineBillMasters.reduce((total, bill) => {
    const barItemTotalInBill = bill.BillItems
      .filter(item => !item.isFood && item.itemQty > 0 && !item.isCancelled && !item.isComplementory)
      .reduce((itemTotal, item) => itemTotal + item.itemAmt, 0);

    return total + barItemTotalInBill;
  }, 0);

  const barItemsList = onlineBillMasters.flatMap(bill =>
    bill.BillItems.filter(item => 
      item.isFood && 
      item.itemQty > 0 && 
      !item.isCancelled && 
      !item.isComplementory
    )
  );
  
  barItemsList.sort((a, b) => a.billItemId - b.billItemId);

console.log("Bar Items List:", barItemsList);

  const FoodAndBarItemTotal = FoodItemTotal + BarItemTotal;

  const sgstTotal = billNoTableData.reduce((sgstAcc, bill) => {
    const billSgst = bill.BillItems.reduce((itemSgstAcc, item) => {
      if (item.itemQty > 0 && !item.isCancelled && !item.isComplementory) {
        return itemSgstAcc + (item.sgstAmt || 0);
      }
      return itemSgstAcc;
    }, 0);
    return sgstAcc + billSgst;
  }, 0);

  const cgstTotal = billNoTableData.reduce((cgstAcc, bill) => {
    const billCgst = bill.BillItems.reduce((itemCgstAcc, item) => {
      if (item.itemQty > 0 && !item.isCancelled && !item.isComplementory) {
        return itemCgstAcc + (item.cgstAmt || 0);
      }
      return itemCgstAcc;
    }, 0);
    return cgstAcc + billCgst;
  }, 0);

  const sgstTotalandcgstTotal = sgstTotal + cgstTotal;

  const vatTotal = billNoTableData.reduce((vatAcc, bill) => {
    const billVat = bill.BillItems.reduce((itemVatAcc, item) => {
      if (item.itemQty > 0 && !item.isCancelled && !item.isComplementory) {
        return itemVatAcc + (item.vatAmt || 0);
      }
      return itemVatAcc;
    }, 0);
    return vatAcc + billVat;
  }, 0);

  const FoodDisc = onlineBillMasters.reduce((total, bill) => {
    return total + (bill.discFood || 0);
  }, 0);

  const BarDisc = onlineBillMasters.reduce((total, bill) => {
    return total + (bill.discBar || 0);
  }, 0);


  const FoodDiscandBarDiscTotal = FoodDisc + BarDisc;

  const TotalServiceCharge = onlineBillMasters.reduce((total, bill) => {
    return total + (bill.serviceCharge || 0);
  }, 0);

  const totalRoundOff = billNoTableData.reduce((total, bill) => {
    return total + (bill.roundOff || 0);
  }, 0);
  const totalCash = onlineBillMasters.reduce((total, cash) => {
    return total + (cash.Cash || 0);
  }, 0);
  const totalCard = onlineBillMasters.reduce((total, card) => {
    return total + (card.Card || 0);
  }, 0);
  const totalCredit = onlineBillMasters.reduce((total, credit) => {
    return total + (credit.Credit || 0);
  }, 0);
  const totalGpay = onlineBillMasters.reduce((total, gpay) => {
    return total + (gpay.Gpay || 0);
  }, 0);
  const totalRmTr = onlineBillMasters.reduce((total, rmTr) => {
    return total + (rmTr.RmTr || 0);
  }, 0);



  const CalculateTotalSale =
    FoodAndBarItemTotal +
    totalRoundOff +
    sgstTotalandcgstTotal +
    vatTotal +
    TotalServiceCharge -
    FoodDiscandBarDiscTotal;



  // OPEN TABLE TOTAL (ALL ITEMS)
  const OpenTableAllItemTotal = onlineBillMasters
    .filter(bill => !bill.isPrinted && !bill.isSettled)
    .reduce((total, bill) => {
      const allItemTotal = bill.BillItems
        .filter(item => item.itemQty > 0 && !item.isCancelled && !item.isComplementory)
        .reduce((itemTotal, item) => itemTotal + item.itemAmt, 0);
      return total + allItemTotal;
    }, 0);

  // UNPAID TABLE TOTAL (ALL ITEMS)
  const UnpaidTableAllItemTotal = onlineBillMasters
    .filter(bill => bill.isPrinted && !bill.isSettled)
    .reduce((total, bill) => {
      const allItemTotal = bill.BillItems
        .filter(item => item.itemQty > 0 && !item.isCancelled && !item.isComplementory)
        .reduce((itemTotal, item) => itemTotal + item.itemAmt, 0);
      return total + allItemTotal;
    }, 0);

    const UnpaidTableTaxesRndOff = unpaidTableData.reduce(
      (total, item) => total + (item.taxAmt || 0) + (item.roundOff || 0),
      0
    );
    
    


  // PAID TABLE TOTAL (ALL ITEMS)
  const PaidTableAllItemTotal = onlineBillMasters
    .filter(bill => bill.isPrinted && bill.isSettled)
    .reduce((total, bill) => {
      const allItemTotal = bill.BillItems
        .filter(item => item.itemQty > 0 && !item.isCancelled && !item.isComplementory)
        .reduce((itemTotal, item) => itemTotal + item.itemAmt, 0);
      return total + allItemTotal;
    }, 0);

  const AllItemTotal = onlineBillMasters

    .reduce((total, bill) => {
      const allItemTotal = bill.BillItems
        .filter(item => item.itemQty > 0 && !item.isCancelled && !item.isComplementory)
        .reduce((itemTotal, item) => itemTotal + item.itemAmt, 0);
      return total + allItemTotal;
    }, 0);


  // Alert Messages


  useEffect(() => {
    const unreadMessages = messagedata.filter(msg => !msg.read);
    console.log("unread", unreadMessages.length);
    if (unreadMessages.length > 0) {
      playAudio();
    }
  }, [messagedata]);




  const playAudio = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio(AlertMessageAudio);
      audioRef.current.loop = true; // Enable loop
    }

    audioRef.current.play().catch((error) => {
      console.log("Audio play error:", error);
    });
  };

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0; // Reset audio to start
    }
  };
  
  const schedulerTypes = [...new Set(messagedata.map(item => item.Scheduler_type))];


  const viewStatusUpdate = async () => {
    if (!viewMessageId) return;
    try {
      const viewresp = await axios.put(`${process.env.REACT_APP_SERVER_API}updateReadStatus`, {
        outletId: outlet?.outlate_id
    });
    
      console.log("Status Updated Successfully", viewresp.data);


      stopAudio();


      setViewMessageId(null);

    } catch (error) {
      console.log("View Message Status Api Error", error);
    }
  };

  return (
    <>
      <div className="container-fluid mt-2">
        <div><h5 className="text-center mt-2">{outlet?.Outlate_Name}</h5></div>
        <div className="d-flex justify-content-between mt-3">


          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault2"
              checked={dateOption === "back"}
              onChange={() => setDateOption("back")}
            />
            <label className="form-check-label" htmlFor="flexRadioDefault2">
              Back Date
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault1"
              checked={dateOption === "current"}
              onChange={() => setDateOption("current")}
            />
            <label className="form-check-label" htmlFor="flexRadioDefault1">
              Current Date
            </label>
          </div>
        </div>

        <div className="col-md-6 mt-2 d-flex">
          <input
            type="date"
            className="form-control me-2 p-0"
            style={{ width: "40%", fontSize: "15px", height: "22px" }}
            value={selectedDate}
            onChange={handleDateChange}
            disabled={dateOption === "current"}

          />
          <button className="btn btn-primary" onClick={handleShowClick}
            disabled={
              dateOption === "back" &&
              new Date(selectedDate).toDateString() === new Date().toDateString()
            }
            style={{ width: "20%", fontSize: "15px", height: "22px", lineHeight: "10px" }}
          >Show</button>
           

           <Link to="/ReportsDashboard" className="btn btn-success"
            style={{ width: "20%", fontSize: "15px", height: "22px", lineHeight: "10px" , marginLeft:"50px"}}
           >Reports</Link>
        </div>
        {dateOption === "back" && (
          <div className="col-md-6 mt-2 d-flex">
            <button onClick={handlePrevDate} className="btn btn-success me-3"
              style={{ width: "20%", fontSize: "15px", height: "22px", lineHeight: "10px" }}
            >Prev</button>
            <button onClick={handleNextDate} className="btn btn-success"
              disabled={new Date(selectedDate) >= new Date(new Date().setDate(new Date().getDate() - 2))}
              style={{ width: "20%", fontSize: "15px", height: "22px", lineHeight: "10px" }}
            >Next</button>
          </div>
        )}

        {/* Table Categories */}
        <div className="row d-flex justify-content-center">
          <div className="col-md-6 mt-3">
            <div className="border p-2">

              {dateOption == "current" ? (
                <h6>Current Status</h6>
              ) : (
                <h6>Backdated Status</h6>
              )}

              <div className="border">

                  {/* Alert Message */}

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingNine">
                      <button
                        className="accordion-button collapsed p-2"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseNine"
                        aria-expanded="false"
                        aria-controls="flush-collapseNine"
                      >
                        Alert Messages
                      </button>
                    </h2>
                    <div
                      id="flush-collapseNine"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingNine"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body custom-scroll">
                        <div className="table-responsive" style={{ maxHeight: '400px', width: '100%', overflowY: 'auto' }}>
                          <div className="accordion accordion-flush" id="accordionFlushExampleNested">
                            {schedulerTypes.map((schedulerType, index) => {
                              // Filter data for the selected Scheduler_type
                              const filteredData = messagedata.filter(item => item.Scheduler_type === schedulerType);

                              return (
                                <div className="accordion-item" key={schedulerType}>
                                  <h2 className="accordion-header" id={`flush-heading${index}`}>
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#flush-collapse${index}`}
                                      aria-expanded="false"
                                      aria-controls={`flush-collapse${index}`}
                                    >
                                      {schedulerType}
                                    </button>
                                  </h2>
                                  <div
                                    id={`flush-collapse${index}`}
                                    className="accordion-collapse collapse"
                                    aria-labelledby={`flush-heading${index}`}
                                    data-bs-parent="#accordionFlushExampleNested" // Change this to ensure correct parent-child relationship
                                  >
                                    <div className="accordion-body">
                                      {filteredData.length === 0 ? (
                                        <p>No messages for this Scheduler Type</p>
                                      ) : (
                                        filteredData.map(item => (
                                          <div key={item._id}>
                                            <p><strong>Message:</strong> {item.Message}</p>
                                            <p><strong>Bill Date:</strong> {new Date(item.billDate).toLocaleDateString()}</p>
                                            <p><strong>Status:</strong> {item.read ? 'Read' : 'Unread'}</p>
                                            <div>
                                              <button
                                                className="btn btn-primary"
                                                // disabled={!isPlaying}
                                                onClick={() => {
                                                  setViewMessageId(item._id);
                                                  viewStatusUpdate();
                                                }}
                                              >
                                                {item.read ? "Unread" : "Read"}
                                              </button>
                                            </div>
                                          </div>
                                        ))
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Sale Summary Tables */}
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFive">
                      <button
                        className="accordion-button collapsed p-2"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFive"
                        aria-expanded="false"
                        aria-controls="flush-collapseFive"
                      >
                        Sale Summary
                      </button>
                    </h2>
                    <div
                      id="flush-collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingFive"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body custom-scroll ">
                        {FoodItemTotal > 0 && (
                          <div className="row">
                            <div className="col-6 ">Food Item Total</div>
                            <div className="col-3 text-end">{FoodItemTotal.toFixed(2)}</div>
                            <div className="col-3"></div>

                          </div>
                        )}
                        {BarItemTotal > 0 && (
                          <div className="row">
                            <div className="col-6">Bar Item Total</div>
                            <div className="col-3 text-end">{BarItemTotal.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {FoodAndBarItemTotal > 0 && (
                          <div className="row border-top border-bottom">
                            <div className="col-5"></div>
                            <div className="col-4 "><b>Item Total</b></div>
                            <div className="col-3 text-end"><b>{FoodAndBarItemTotal.toFixed(2)}</b></div>
                          </div>
                        )}

                        {OpenTableAllItemTotal > 0 && (

                          <div className="row">
                            <div className="col-6">Open Table</div>
                            <div className="col-3 text-end">{OpenTableAllItemTotal.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {UnpaidTableAllItemTotal > 0 && (
                          <div className="row">
                            <div className="col-6">Unpaid Table</div>
                            <div className="col-3 text-end">{(UnpaidTableAllItemTotal + UnpaidTableTaxesRndOff).toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {PaidTableAllItemTotal > 0 && (
                          <div className="row">
                            <div className="col-6">Paid Table</div>
                            <div className="col-3 text-end">{PaidTableAllItemTotal.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {AllItemTotal > 0 && (
                          <div className="row border-top border-bottom">
                            <div className="col-4"></div>
                            <div className="col-5"><b>Table Total</b></div>
                            <div className="col-3 text-end"><b>{(AllItemTotal+UnpaidTableTaxesRndOff).toFixed(2)}</b></div>
                          </div>
                        )}
                        {cgstTotal > 0 && (
                          <div className="row">
                            <div className="col-6">CGST</div>
                            <div className="col-3 text-end">{cgstTotal.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {sgstTotal > 0 && (
                          <div className="row">
                            <div className="col-6">SGST</div>
                            <div className="col-3 text-end">{sgstTotal.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {sgstTotalandcgstTotal > 0 && (
                          <div className="row border-top ">
                            <div className="col-4"></div>
                            <div className="col-5">Total GST</div>
                            <div className="col-3 text-end">{sgstTotalandcgstTotal.toFixed(2)}</div>
                          </div>
                        )}
                        {vatTotal > 0 && (
                          <div className="row border-bottom">
                            <div className="col-4"></div>
                            <div className="col-5">Vat Total</div>
                            <div className="col-3 text-end">{vatTotal.toFixed(2)}</div>
                          </div>
                        )}
                        {FoodDisc > 0 && (
                          <div className="row border-bottom">
                            <div className="col-6">Food Disc</div>
                            <div className="col-3 text-end">{FoodDisc.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {BarDisc > 0 && (
                          <div className="row">
                            <div className="col-6">Bar Disc</div>
                            <div className="col-3 text-end">{BarDisc.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {FoodDiscandBarDiscTotal > 0 && (
                          <div className="row border-top border-bottom">
                            <div className="col-4"></div>
                            <div className="col-5"><b>Total Disc</b></div>
                            <div className="col-3 text-end"><b>{FoodDiscandBarDiscTotal.toFixed(2)}</b></div>
                          </div>
                        )}
                        {TotalServiceCharge > 0 && (
                          <div className="row border-bottom">
                            <div className="col-6">Service Charge</div>
                            <div className="col-3"></div>
                            <div className="col-3 text-end">{TotalServiceCharge.toFixed(2)}</div>
                          </div>
                        )}
                       {totalRoundOff && (
                          <div className="row border-bottom">
                            <div className="col-6">Round Off</div>
                            <div className="col-3"></div>
                            <div className="col-3 text-end">{totalRoundOff.toFixed(2)}</div>
                          </div>
                          )}
                       
                        {CalculateTotalSale > 0 && (
                          <div className="row">
                            <div className="col-6"><b>Total Sale</b></div>
                            <div className="col-3"></div>
                            <div className="col-3 text-end"><b>{(CalculateTotalSale+UnpaidTableTaxesRndOff).toFixed(2)}</b></div>
                          </div>
                        )}
                        {totalCash > 0 && (
                          <div className="row border-bottom">
                            <div className="col-6">Cash</div>
                            
                            <div className="col-3 text-end">{totalCash.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {totalCard > 0 && (
                          <div className="row border-bottom">
                            <div className="col-6">Card</div>
                            
                            <div className="col-3 text-end">{totalCard.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {totalCredit > 0 && (
                          <div className="row border-bottom">
                            <div className="col-6">Credit</div>
                            
                            <div className="col-3 text-end">{totalCredit.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {totalGpay > 0 && (
                          <div className="row border-bottom">
                            <div className="col-6">GPay/UPI Pay</div>
                            
                            <div className="col-3 text-end">{totalGpay.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        {totalRmTr > 0 && (
                          <div className="row border-bottom">
                            <div className="col-6">Room Tr.</div>
                            
                            <div className="col-3 text-end">{totalRmTr.toFixed(2)}</div>
                            <div className="col-3"></div>
                          </div>
                        )}
                        




                      </div>
                    </div>
                  </div>


                <div className="accordion accordion-flush" id="accordionFlushExample">
                  {/* Open Tables */}
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingOne">
                      <button
                        className="accordion-button collapsed p-2"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne"
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                      >
                        Open Table/s
                      </button>
                    </h2>
                    <div
                      id="flush-collapseOne"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingOne"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body custom-scroll">
                        {openTableData.length > 0 ? (
                          <>

                            <div className="d-flex flex-wrap p-2">
                              {openTableData.map((bill) => (
                                <button
                                  key={bill.srNumber}
                                  className="btn btn-primary m-1 p-1"
                                  style={{ width: "50px" }}
                                  onClick={() => handleTableClick(bill)}
                                >
                                  {bill.tblno}
                                </button>
                              ))}
                            </div>
                          </>
                        ) : (
                          <p>No open tables available.</p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Unpaid Tables */}
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTwo">
                      <button
                        className="accordion-button collapsed p-2"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        Unpaid Table/s
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body custom-scroll">
                        {unpaidTableData.length > 0 ? (
                          <>
                            <div className="d-flex flex-wrap p-2">
                              {unpaidTableData.map((bill) => (
                                <button
                                  key={bill.srNumber}
                                  className="btn btn-warning m-1 p-1"
                                  style={{ width: "50px" }}
                                  onClick={() => handleTableClick(bill)}
                                >
                                  {bill.tblno}
                                </button>
                              ))}
                            </div>
                          </>
                        ) : (
                          <p>No unpaid tables available.</p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Settled Tables */}
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingThree">
                      <button
                        className="accordion-button collapsed p-2"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseThree"
                        aria-expanded="false"
                        aria-controls="flush-collapseThree"
                      >
                        Paid Table/s
                      </button>
                    </h2>
                    <div
                      id="flush-collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingThree"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body custom-scroll">
                        {billNoTableData.filter(bill => bill.billNo >= 0).length > 0 ? (
                          <>
                            <div className="d-flex flex-wrap p-2">
                              {billNoTableData.filter(bill => bill.billNo >= 0).map((bill) => (
                                <button
                                  key={bill.srNumber}
                                  className="btn btn-success m-1 p-1"
                                  style={{ width: "76px", textAlign: "center" }}
                                  onClick={() => handleTableClick(bill)}
                                >
                                  {bill.tblno}
                                </button>
                              ))}
                            </div>
                          </>
                        ) : (
                          <p>No settled tables available.</p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Drop Tables */}
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFour">
                      <button
                        className="accordion-button collapsed p-2"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFour"
                        aria-expanded="false"
                        aria-controls="flush-collapseFour"
                      >
                        Drop Table/s
                      </button>
                    </h2>
                    <div
                      id="flush-collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingFour"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body custom-scroll">
                        {billNoTableData.filter(bill => bill.billNo < 0).length > 0 ? (
                          <>
                            <div className="d-flex flex-wrap p-2">
                              {billNoTableData.filter(bill => bill.billNo < 0).map((bill) => (
                                <button
                                  key={bill.srNumber}
                                  className="btn btn-danger m-1 p-1"
                                  style={{ width: "76px", textAlign: "center" }}
                                  onClick={() => handleTableClick(bill)}
                                >
                                  {bill.tblno}
                                </button>
                              ))}
                            </div>
                          </>
                        ) : (
                          <p>No drop tables available.</p>
                        )}
                      </div>
                    </div>
                  </div>

                

                  {/* Cancel Item */}
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingSix">
                      <button
                        className="accordion-button collapsed p-2"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseSix"
                        aria-expanded="false"
                        aria-controls="flush-collapseSix"
                      >
                        Cancel Item
                      </button>
                    </h2>
                    <div
                      id="flush-collapseSix"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingSix"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body custom-scroll ">
                        <div className="table-responsive" style={{ maxHeight: '400px', width: "400px", overflowY: 'auto' }}>
                          <table className="table table-bordered table-hover mt-3">
                            <thead className="table-light sticky-top">
                              <tr>
                                <th>Tbl</th>
                                <th>Bill No</th>
                                <th>Item Name</th>
                                <th>Rate</th>
                                <th>Qty</th>
                                <th>Amt</th>
                              </tr>
                            </thead>
                            <tbody>
                              {onlineBillMasters.map(bill =>
                                bill.BillItems
                                  .filter(item => item.CnclQty != 0)
                                  .map(item => (
                                    <tr key={item.billItemId}>
                                      <td>{bill.tblno}</td>
                                      <td>{bill.billNo}</td>
                                      <td>{item.itemName}</td>
                                      <td>{item.itemRate}</td>
                                      <td>{item.CnclQty}</td>
                                      <td>{item.itemRate * item.CnclQty}</td>
                                    </tr>
                                  ))
                              )}
                            </tbody>
                          </table>
                        </div>




                      </div>
                    </div>
                  </div>

                  {/* Complimentry Item */}

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingseven">
                      <button
                        className="accordion-button collapsed p-2"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseseven"
                        aria-expanded="false"
                        aria-controls="flush-collapseseven"
                      >
                        Complimentary Item
                      </button>
                    </h2>
                    <div
                      id="flush-collapseseven"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingseven"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body custom-scroll ">
                        <div className="table-responsive" style={{ maxHeight: '400px', width: "400px", overflowY: 'auto' }}>
                          <div className="table-responsive mt-4" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <table className="table table-bordered table-hover">
                              <thead className="table-light sticky-top">
                                <tr>
                                  <th>Tbl</th>
                                  <th>Bill No</th>
                                  <th>Item Name</th>
                                  <th>Rate</th>
                                  <th>Qty</th>
                                  <th>Amt</th>
                                </tr>
                              </thead>
                              <tbody>
                                {onlineBillMasters.map(bill =>
                                  bill.BillItems
                                    .filter(item => item.isComplementory)
                                    .map(item => (
                                      <tr key={item.billItemId}>
                                        <td>{bill.tblno}</td>
                                        <td>{bill.billNo}</td>
                                        <td>{item.itemName}</td>
                                        <td>{item.itemRate}</td>
                                        <td>{item.itemQty}</td>
                                        <td>{item.itemRate * item.itemQty}</td>
                                      </tr>
                                    ))
                                )}
                              </tbody>
                            </table>
                          </div>

                        </div>




                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingEight">
                      <button
                        className="accordion-button collapsed p-2"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseEight"
                        aria-expanded="false"
                        aria-controls="flush-collapseEight"
                      >
                        Discounts
                      </button>
                    </h2>
                    <div
                      id="flush-collapseEight"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingEight"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body custom-scroll ">
                        <div className="table-responsive" style={{ maxHeight: '400px', width: "400px", overflowY: 'auto' }}>
                          <div className="table-responsive mt-4" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <table className="table table-bordered table-hover">
                              <thead className="table-light sticky-top">
                                <tr>
                                  <th>Tbl</th>
                                  <th>Bill No</th>
                                  <th>Food</th>
                                  <th>Bar</th>
                                  <th>Ttl-Disc</th>
                                </tr>
                              </thead>
                              <tbody>
                                {onlineBillMasters
                                  .filter(bill => bill.discFood + bill.discBar > 0)
                                  .map(bill => (
                                    <tr key={bill.srNumber}>
                                      <td>{bill.tblno}</td>
                                      <td>{bill.billNo}</td>
                                      <td>{bill.discFood}</td>
                                      <td>{bill.discBar}</td>
                                      <td>{bill.discFood + bill.discBar}</td>

                                    </tr>
                                  ))
                                }
                              </tbody>
                            </table>
                          </div>

                        </div>




                      </div>
                    </div>
                  </div>
              

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Bill Details */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Bill Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedBill && (
            <>
              <div className=""
                style={{ fontSize: "12px" }}
              >
                <div className="p-0 m-0 d-flex justify-content-between gap-0">
                  <p className="mb-1"><strong>Table:</strong> {selectedBill.tblno}</p>
                  <p className="mb-1"><strong>Bill No:</strong> {selectedBill.billNo}</p>
                </div>

                <div className="p-0 m-0 d-flex justify-content-between gap-0">
                  <p className="mb-1">
                    <strong>Start:</strong>{" "}
                    {new Date(selectedBill.StartTime).toLocaleTimeString("en-IN", {
                      timeZone: "Asia/Kolkata",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </p>
                  <p className="mb-1">
                    <strong>End:</strong>{" "}
                    {new Date(selectedBill.EndTime ? selectedBill.EndTime : new Date()).toLocaleTimeString("en-IN", {
                      timeZone: "Asia/Kolkata",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </p>
                  {/* Time Difference */}
                  {selectedBill.StartTime && (
                    <p className="mb-1">
                      <strong>Duration:</strong>{" "}
                      {(() => {
                        const start = new Date(selectedBill.StartTime);
                        const end = new Date(selectedBill.EndTime ? selectedBill.EndTime : new Date());

                        let diff = (end - start) / 1000 / 60; // difference in minutes

                        if (diff < 0) {
                          // Add 24 hours if end is before start
                          diff += 24 * 60;
                        }

                        const hours = Math.floor(diff / 60);
                        const minutes = Math.floor(diff % 60);

                        return `${hours}h ${minutes}m`;
                      })()}
                    </p>
                  )}
                </div>
              </div>





              {selectedBill.BillItems.filter(item => item.itemQty > 0).length > 0 ? (
                <>
                  <table className="table table-bordered mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="p-1">Item</th>
                        <th className="p-1">Rate</th>
                        <th className="p-1">Qty</th>
                        <th className="p-1">Amt</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedBill.BillItems.filter(item => item.itemQty > 0).map((item) => (
                        <tr key={item.billItemId}>
                          <td className="border p-1" style={{ fontSize: "13px" }}>{item.itemName}</td>
                          <td className="text-end border p-1" style={{ fontSize: "13px" }}>{item.itemRate.toFixed(2)}</td>
                          <td className="text-center border p-1" style={{ fontSize: "13px" }}>{item.itemQty}</td>
                          <td className="text-end border p-1" style={{ fontSize: "13px" }}>{item.itemAmt.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Total Item Amount */}
                  <div className="d-flex justify-content-end mt-1">
                    <strong>Item Amt: ₹{selectedBill.BillItems
                      .filter(item => item.itemQty > 0)
                      .reduce((acc, item) => acc + item.itemAmt, 0).toFixed(2)}</strong>
                  </div>
                </>
              ) : (
                <p>No items to display.</p>
              )}

              {(taxes.totalCgst + taxes.totalSgst) > 0 && (
                <div className="d-flex align-items-center gap-0 mb-1" style={{ fontSize: "12px" }}>
                  <p className="me-2 mb-0" style={{ width: "100px" }}>
                    <strong>CGST:</strong> {taxes.totalCgst.toFixed(2)}
                  </p>
                  <p className="me-2 mb-0" style={{ width: "100px" }}>
                    <strong>SGST:</strong> {taxes.totalSgst.toFixed(2)}
                  </p>
                  <p className="me-1 mb-0" style={{ width: "50px", fontSize: "14px" }}>
                    <strong>GST:</strong>
                  </p>
                  <span className="text-end mb-0" style={{ fontSize: "14px" }}>
                    {(taxes.totalSgst + taxes.totalCgst).toFixed(2)}
                  </span>
                </div>
              )}



              {taxes.totalVat > 0 && (
                <div className="d-flex justify-content-end align-items-center p-0 gap-0 mb-1" style={{ fontSize: "14px" }}>
                  <p className="me-1 mb-0" style={{ width: "50px" }}>
                    <strong>VAT:</strong>
                  </p>
                  <span className="text-end mb-0">
                    {taxes.totalVat.toFixed(2)}
                  </span>
                </div>
              )}

              {(selectedBill.discFood + selectedBill.discBar) > 0 && (
                <div className="d-flex align-items-center gap-0 mb-1" style={{ fontSize: "12px" }}>
                  <p className="me-2 mb-0" style={{ width: "100px" }}>
                    <strong>Disc Food:</strong> {selectedBill.discFood.toFixed(2)}
                  </p>
                  <p className="me-2 mb-0" style={{ width: "100px" }}>
                    <strong>Disc Bar:</strong> {selectedBill.discBar.toFixed(2)}
                  </p>
                  <p className="me-1 mb-0" style={{ width: "50px", fontSize: "14px" }}>
                    <strong>Disc:</strong>
                  </p>
                  <span className="text-end mb-0" style={{ fontSize: "14px" }}>
                    {(selectedBill.discFood + selectedBill.discBar).toFixed(2)}
                  </span>
                </div>
              )}


              {/* )} */}

              {selectedBill.roundOff  && (
                <div style={{ marginLeft: "63%" }} className="d-flex">
                  <p className="me-1 mb-0" style={{ width: "70px", fontSize: "14px" }}>
                    <strong>Rnd Off:</strong>
                  </p>
                  <span className="text-end mb-0" style={{ fontSize: "14px" }}>
                    {(selectedBill.roundOff).toFixed(2)}
                  </span>

                </div>
              )}
              <hr className="mt-0 mb-0" />

              <div className="d-flex justify-content-end px-2">
                <p style={{ fontSize: "14px", marginBottom: 0 }}>
                  <strong className="me-3">Bill Total:</strong>
                </p>
                <p style={{ fontSize: "14px", marginBottom: 0 }}>
                  ₹{selectedBill.billAmt > 0
                    ? selectedBill.billAmt.toFixed(2)
                    : (
                      selectedBill.BillItems
                        .filter(item => item.itemQty > 0)
                        .reduce((acc, item) => acc + item.itemAmt, 0) +
                      taxes.totalCgst +
                      taxes.totalSgst +
                      taxes.totalVat +
                      selectedBill.roundOff -
                      (selectedBill.discFood + selectedBill.discBar)
                    ).toFixed(2)
                  }
                </p>
              </div>
              <hr className="mt-0 mb-0" />




              {(selectedBill.Cash > 0 || selectedBill.Card > 0 || selectedBill.Gpay > 0) && (
                <>
                  <h6 className="text-center mt-0 mb-1">Payment Details</h6>
                  <div className="d-flex justify-content-between gap-2 px-2">
                    {selectedBill.Cash > 0 && (
                      <p className="mb-0"><strong>Cash:</strong> ₹{selectedBill.Cash}</p>
                    )}
                    {selectedBill.Card > 0 && (
                      <p className="mb-0"><strong>Card:</strong> ₹{selectedBill.Card}</p>
                    )}
                    {selectedBill.Gpay > 0 && (
                      <p className="mb-0"><strong>Gpay:</strong> ₹{selectedBill.Gpay}</p>
                    )}
                  </div>
                </>
              )}


            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LiveTableStatus;
